export function guideAllowsCompany(guide, companyId) {
  const settings = guide.settings || {}
  return (settings.company_scope || 'all') === 'all' || (settings.company_ids || []).some(id => Number(id) === Number(companyId))
}

export function guideMatchesTemplate(guide, context) {
  const settings = guide.settings || {}
  if (settings.template_scope !== 'selected') return true
  if (!context || !context.ready || context.templateAmbiguous || Number(context.pageId) !== Number(guide.pages_id)) return false
  return (settings.templates || []).some(template => Number(template.variant) === Number(context.variant) && template.key === context.templateKey)
}

export function guideAvailableHere(guide, companyId, pageId, context) {
  return guideAllowsCompany(guide, companyId) && guideMatchesTemplate(guide, context)
    && (guide.global || !guide.pages_id || Number(guide.pages_id) === Number(context ? context.pageId : pageId))
}

export function guideSettings(settings = {}) {
  return { ...settings, feedback_enabled: settings?.feedback_enabled !== false,
    company_scope: settings?.company_scope || 'all', company_ids: settings?.company_ids || [],
    template_scope: settings?.template_scope || 'all', templates: settings?.templates || [],
  }
}

export function templateIdentity(template) { return JSON.stringify([Number(template.variant), template.key]) }
